import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

/**
 * "My Accessories Cart" headline.
 * Still has legacy CSS for the tooltip-item.
 *
 * SEE ALSO nol_core_cart.html.haml - this renders another headline with similar structure.
 *
 * @param coreCart
 * @param props
 * @returns {React.JSX.Element|null}
 * @constructor
 */
const MultiCartHeadline = ({coreCart, ...props}) => {
  if (!coreCart || !coreCart.itemCount)
    return null;

  //const {itemCount, cartUrl, cartCode, subtotalMoney} = coreCart;

  return (
    <div id="my-accessories-cart-headline"
      className="multi-cart-headline  lg:w-3/4 mb-4 text-brand-dark border-b-4 border-brand-orange">
      <span className="text-2xl font-aileron">My Accessories Cart</span>

      <div className="tooltip-item">
        <i className="fas fa-info-circle"></i>
        <div className="tooltip">
          <p>NAPA Custom Accessories ship directly to your door and may not be available in-store.</p>
        </div>
      </div>
    </div>
  );
}

// MultiCartHeadline.propTypes = { }

export default MultiCartHeadline;
